// Client ID and API key from the Developer Console
let CLIENT_ID = "786201101799-8k4i63593cvqn58ep5cthb9rd55o181a.apps.googleusercontent.com";

// let CLIENT_SECRET = "r6hNA-jC7Ubnh5LNALZtU3Xz";
let API_KEY = "AIzaSyA9yn57MP0K5YYVMXiV-4kbzlpf88Mz29I";

// Array of API discovery doc URLs for APIs used by the quickstart
let DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest"];

// Authorization scopes required by the API; multiple scopes can be
// included, separated by spaces.
// let SCOPES = "https://www.googleapis.com/auth/calendar.readonly";
let SCOPES = "https://www.googleapis.com/auth/calendar";

export default {
  apiKey: API_KEY,
  clientId: CLIENT_ID,
  discoveryDocs: DISCOVERY_DOCS,
  scope: [SCOPES]
};
